import { Locale } from '../i18n'

export interface PercentHook {
  formatPercent: (input?: string | number | null) => string
}
export interface PercentConfig {
  locale?: Locale | 'default'
  decimalPlaces?: number
  shouldDivideBy100?: boolean
}

export const usePercent = ({ locale = 'default', decimalPlaces, shouldDivideBy100 = false }: PercentConfig): PercentHook => {
  const formattingOptions: Intl.NumberFormatOptions = {
    style: 'percent',
    ...(typeof decimalPlaces !== 'undefined' && {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }),
  }
  const formatter = new Intl.NumberFormat(locale, formattingOptions)

  const formatPercent = (input?: string | number | null): string => {
    let numericAmount = Number(input) || 0

    if (shouldDivideBy100) {
      numericAmount /= 100
    }

    return formatter.format(numericAmount)
  }

  return { formatPercent }
}
